export const getSessionId = (responseLocation?: string) => {
    if (!responseLocation) return ''

    const sessionId = responseLocation.split('sessions/')[1]

    if (!sessionId) return ''

    return sessionId
}
